module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/381.a00fb693.png";